var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { BsArrowRight, BsCheck2, BsClipboard, BsHeartFill, BsStarFill } from 'react-icons/bs';
import { useMutation } from 'react-query';
import { axiosClient } from '@app/configure-app';
import { CONTAGEM_SEGUNDOS, COR_ESTRELA, PUT_NPS_URL, TEMPO_MAXIMO_ABRINDO_GOOGLE_MS, TIMEOUT_ACESSO_GOOGLE_MS, } from '../../nps.constants';
import { copiarTexto } from '../../nps.utils';
import { NpsBotao } from '../nps-botao';
import { NpsTelaCheia } from '../nps-tela';
import { useContagemRegressiva } from './contagem-regressiva.hook';
import { AcaoCopiarStyled, AnelStyled, BotoesCheiosStyled, CartaoStyled, CartaoTituloStyled, CIRCUNFERENCIA_ANEL, ComentarioCopiadoStyled, ComentarioParaCopiarStyled, ContagemStyled, EstrelasStyled, IconeCirculoStyled, InstrucaoStyled, NumeroAnelStyled, ProgressoAnelStyled, TextoCheioStyled, TextoContagemStyled, TituloCheioStyled, TrilhoAnelStyled, } from './nps-promotor.component.style';
var Estrelas = function () { return (React.createElement(EstrelasStyled, { "aria-hidden": "true" }, [1, 2, 3, 4, 5].map(function (estrela) { return (React.createElement(BsStarFill, { key: estrela, size: 12, color: COR_ESTRELA })); }))); };
// Tela 2a: promotor, contagem 3, 2, 1 e redirecionamento para a avaliação do Google da unidade.
export var NpsPromotor = function (_a) {
    var npsId = _a.npsId, urlGoogle = _a.urlGoogle, comentario = _a.comentario, copiou = _a.copiou, onEncerrar = _a.onEncerrar;
    var _b = React.useState(false), abrindo = _b[0], setAbrindo = _b[1];
    var _c = React.useState('pendente'), copiaManual = _c[0], setCopiaManual = _c[1];
    var redirecionandoRef = React.useRef(false);
    var canceladoRef = React.useRef(false);
    var saiuParaGoogleRef = React.useRef(false);
    var montadoRef = React.useRef(true);
    var tituloCartaoRef = React.useRef(null);
    var onEncerrarRef = React.useRef(onEncerrar);
    onEncerrarRef.current = onEncerrar;
    var temComentario = comentario.trim().length > 0;
    var comentarioCopiado = copiou || copiaManual === 'copiado';
    // Sem o texto na área de transferência a contagem espera a pessoa copiar; o botão do Google segue disponível.
    var aguardandoCopia = temComentario && !comentarioCopiado;
    var limiteRef = React.useRef();
    var redirecionar = function () {
        if (canceladoRef.current)
            return;
        saiuParaGoogleRef.current = true;
        window.location.href = urlGoogle;
        // Se o link não abrir nada (ex.: escolha de app fechada), não deixa a tela presa em "Abrindo o Google…".
        limiteRef.current = window.setTimeout(function () { return onEncerrarRef.current(); }, TEMPO_MAXIMO_ABRINDO_GOOGLE_MS);
    };
    // Ao voltar do Google (app aberto por cima da página ou botão voltar, que restaura a página como estava),
    // segue para o Obrigado em vez de deixar os botões travados em "Abrindo o Google…".
    React.useEffect(function () {
        var aoVoltar = function (evento) {
            if (!saiuParaGoogleRef.current)
                return;
            if (evento.type === 'pageshow' || document.visibilityState === 'visible')
                onEncerrarRef.current();
        };
        window.addEventListener('pageshow', aoVoltar);
        document.addEventListener('visibilitychange', aoVoltar);
        return function () {
            // A PUT de acesso pode terminar depois de a pessoa sair da tela: não redireciona nem cria o timer.
            canceladoRef.current = true;
            montadoRef.current = false;
            window.removeEventListener('pageshow', aoVoltar);
            document.removeEventListener('visibilitychange', aoVoltar);
            window.clearTimeout(limiteRef.current);
        };
    }, []);
    // Registra o acesso ao Google; em erro ou demora acima de 3s redireciona mesmo assim (DT-04).
    var registrarAcesso = useMutation(function () {
        return axiosClient.put(PUT_NPS_URL + "/" + npsId, { acessoGoogleMeuNegocio: true, urlGoogleMeuNegocio: urlGoogle }, { timeout: TIMEOUT_ACESSO_GOOGLE_MS });
    }, {
        onError: function (error) { return console.error('Erro ao registrar acesso ao Google:', error); },
        onSettled: redirecionar,
    }).mutate;
    var abrirGoogle = function () {
        if (redirecionandoRef.current || canceladoRef.current)
            return;
        redirecionandoRef.current = true;
        setAbrindo(true);
        registrarAcesso();
    };
    var handleAgoraNao = function () {
        if (redirecionandoRef.current)
            return;
        canceladoRef.current = true;
        onEncerrar();
    };
    // A cópia roda dentro do toque, como no envio (DT-01).
    var copiarComentario = function () { return __awaiter(void 0, void 0, void 0, function () {
        var copiado;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, copiarTexto(comentario.trim())];
                case 1:
                    copiado = _b.sent();
                    if (!montadoRef.current)
                        return [2 /*return*/];
                    // Uma falha que chega atrasada não desfaz a cópia já feita pelo menu do sistema (onCopy).
                    setCopiaManual(function (atual) { return (copiado || atual === 'copiado' ? 'copiado' : 'falhou'); });
                    // A cópia usa um campo temporário que leva o foco (e o botão some ao copiar): devolve o foco ao título do cartão,
                    // também numa segunda falha seguida, em que o estado não muda.
                    (_a = tituloCartaoRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    return [2 /*return*/];
            }
        });
    }); };
    var restante = useContagemRegressiva(CONTAGEM_SEGUNDOS, !abrindo && !aguardandoCopia, abrirGoogle);
    var tituloCartao = 'Copie seu comentário abaixo';
    if (comentarioCopiado)
        tituloCartao = 'Seu comentário já está copiado';
    else if (copiaManual === 'falhou')
        tituloCartao = 'Toque e segure o texto para copiar';
    var textoContagem = "Levando voc\u00EA ao Google em " + restante + "\u2026";
    if (abrindo)
        textoContagem = 'Abrindo o Google…';
    else if (copiaManual === 'falhou')
        textoContagem = 'Depois de copiar, toque em Avaliar no Google agora';
    else if (aguardandoCopia)
        textoContagem = 'A contagem começa quando você copiar o comentário';
    return (React.createElement(NpsTelaCheia, { alinhamentoTopo: "40px", circuloSuperior: { diametro: 400, esquerda: '100%' }, circuloInferior: { diametro: 260, topo: '600px' } },
        React.createElement(IconeCirculoStyled, { "aria-hidden": "true" },
            React.createElement(BsHeartFill, { size: 40 })),
        React.createElement(TituloCheioStyled, null, "Voc\u00EA fez o nosso dia!"),
        React.createElement(TextoCheioStyled, null, "Que tal contar isso no Google? Leva menos de um minuto, ajuda outras pessoas a nos encontrarem e \u00E9 o maior presente para a nossa equipe."),
        React.createElement(CartaoStyled, null,
            temComentario && (React.createElement(React.Fragment, null,
                React.createElement(CartaoTituloStyled, { ref: tituloCartaoRef, tabIndex: -1, "$confirmado": comentarioCopiado },
                    comentarioCopiado && React.createElement(BsCheck2, { size: 14, "aria-hidden": "true" }),
                    tituloCartao),
                comentarioCopiado ? (React.createElement(ComentarioCopiadoStyled, null,
                    "\u201C",
                    comentario.trim(),
                    "\u201D")) : (React.createElement(React.Fragment, null,
                    React.createElement(ComentarioParaCopiarStyled, { onCopy: function () { return setCopiaManual('copiado'); } }, comentario.trim()),
                    React.createElement(AcaoCopiarStyled, null,
                        React.createElement(NpsBotao, { variante: "primario", onClick: copiarComentario },
                            "Copiar coment\u00E1rio",
                            React.createElement(BsClipboard, { size: 16, "aria-hidden": "true" }))))))),
            React.createElement(InstrucaoStyled, { "$comMargem": temComentario },
                React.createElement("span", null, temComentario
                    ? 'No Google, toque nas 5 estrelas e cole seu texto.'
                    : 'No Google, toque nas 5 estrelas e conte em poucas palavras.'),
                React.createElement(Estrelas, null))),
        React.createElement(ContagemStyled, null,
            React.createElement(AnelStyled, { "aria-hidden": "true" },
                React.createElement("svg", { width: "80", height: "80", viewBox: "0 0 80 80" },
                    React.createElement(TrilhoAnelStyled, null),
                    React.createElement(ProgressoAnelStyled, { "$segundos": CONTAGEM_SEGUNDOS, "$pausado": aguardandoCopia || abrindo, strokeDashoffset: abrindo ? CIRCUNFERENCIA_ANEL : 0 })),
                React.createElement(NumeroAnelStyled, null, Math.max(restante, 1))),
            React.createElement(TextoContagemStyled, { "aria-live": "polite" }, textoContagem),
            React.createElement(BotoesCheiosStyled, null,
                React.createElement(NpsBotao, { variante: "branco", sobreMarca: true, disabled: abrindo, onClick: abrirGoogle },
                    "Avaliar no Google agora",
                    React.createElement(BsArrowRight, { size: 16, "aria-hidden": "true" })),
                React.createElement(NpsBotao, { variante: "texto", sobreMarca: true, disabled: abrindo, onClick: handleAgoraNao }, "Agora n\u00E3o")))));
};
